import { StorefrontIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Store = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <StorefrontIcon size={Sizes[size]} {...rest} color={fill} />;
};

Store.displayName = 'Store';
